import React, { useContext, useState } from 'react';
import ReportListingTable from './report_listing/ReportListing';
import { useTranslation } from 'react-i18next';
import RequirementListing from './requirement_listing/RequirementListing';
import NewProjectListing from './new_project_contact_listing/NewProjectListing';
import ContactUsListing from './contact_us_listing/ContactUsListing';

import classNames from 'classnames';
import AuthContext from 'context/AuthContext';
import PropertListing from './property_listing/PropertListing';
import BlogListing from './blog_listing/BlogListing';
import SuggestionComplaintsListing from './suggestions_complaints_listing/SuggestionComplaintListing';

const tabBtnClass =
  'ml-3 inline-block py-3 px-2 text-md xl:text-sm font-semibold border-b-2';
const tabActiveClass = 'border-lime-500 text-lime-500';
const tabBorderNoneClass = 'border-transparent';
const TAB_REPORTED_LISTING = 'reported_listing';
const TAB_REQUIREMENT_LISTING = 'requirement_listing';
const TAB_NEW_PROJECT_LISTING = 'new_project_contact_listing';
const TAB_CONTACT_US_LISTING = 'contact_us_listing';
const TAB_PROPERTY_LISTING = 'property_listing';
const TAB_BLOG_LISTING = 'blog_listing';
const TAB_SUGGESTION_AND_COMPLAINT_LISTING = 'suggestion_and_complaint_listing';

function Query() {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const manager =
    user?.permission?.find((e) => e.manager === 'query_listing_manager') ?? {};
  const [defaultTab, setDefaultTab] = useState('reported_listing');
  const handleTabClick = (action, e) => {
    setDefaultTab(action);
  };
  return (
    <div>
      <div className="pb-3">
        <ul className="border-b flex">
          <li className="mr-0">
            <button
              onClick={handleTabClick.bind(this, TAB_REPORTED_LISTING)}
              className={classNames({
                [tabBtnClass]: true,
                [tabActiveClass]: defaultTab === TAB_REPORTED_LISTING,
                [tabBorderNoneClass]: defaultTab !== TAB_REPORTED_LISTING,
              })}
            >
              {t('O_REPORTED_LISTING')}
            </button>
          </li>
          <li className="mx-0">
            <button
              onClick={handleTabClick.bind(this, TAB_REQUIREMENT_LISTING)}
              className={classNames({
                [tabBtnClass]: true,
                [tabActiveClass]: defaultTab === TAB_REQUIREMENT_LISTING,
                [tabBorderNoneClass]: defaultTab !== TAB_REQUIREMENT_LISTING,
              })}
            >
              {t('O_REQUIREMENT_LISTING')}
            </button>
          </li>
          <li className="mx-0">
            <button
              onClick={handleTabClick.bind(this, TAB_NEW_PROJECT_LISTING)}
              className={classNames({
                [tabBtnClass]: true,
                [tabActiveClass]: defaultTab === TAB_NEW_PROJECT_LISTING,
                [tabBorderNoneClass]: defaultTab !== TAB_NEW_PROJECT_LISTING,
              })}
            >
              {t('O_NEW_PROJECT_CONTACT_LISTING')}
            </button>
          </li>
          <li className="mx-0">
            <button
              onClick={handleTabClick.bind(this, TAB_CONTACT_US_LISTING)}
              className={classNames({
                [tabBtnClass]: true,
                [tabActiveClass]: defaultTab === TAB_CONTACT_US_LISTING,
                [tabBorderNoneClass]: defaultTab !== TAB_CONTACT_US_LISTING,
              })}
            >
              {t('O_CONTACT_US_LISTING')}
            </button>
          </li>
          <li className="mx-0">
            <button
              onClick={handleTabClick.bind(this, TAB_PROPERTY_LISTING)}
              className={classNames({
                [tabBtnClass]: true,
                [tabActiveClass]: defaultTab === TAB_PROPERTY_LISTING,
                [tabBorderNoneClass]: defaultTab !== TAB_PROPERTY_LISTING,
              })}
            >
              {t('O_PROPERTY_LISTING')}
            </button>
          </li>
          <li className="mx-0">
            <button
              onClick={handleTabClick.bind(this, TAB_BLOG_LISTING)}
              className={classNames({
                [tabBtnClass]: true,
                [tabActiveClass]: defaultTab === TAB_BLOG_LISTING,
                [tabBorderNoneClass]: defaultTab !== TAB_BLOG_LISTING,
              })}
            >
              {t('O_BLOG_LISTING')}
            </button>
          </li>
          <li className="mx-0">
            <button
              onClick={handleTabClick.bind(
                this,
                TAB_SUGGESTION_AND_COMPLAINT_LISTING
              )}
              className={classNames({
                [tabBtnClass]: true,
                [tabActiveClass]:
                  defaultTab === TAB_SUGGESTION_AND_COMPLAINT_LISTING,
                [tabBorderNoneClass]:
                  defaultTab !== TAB_SUGGESTION_AND_COMPLAINT_LISTING,
              })}
            >
              {t('O_SUGGESTION_AND_COMPLAINT_LISTING')}
            </button>
          </li>
        </ul>
      </div>
      {defaultTab === TAB_REPORTED_LISTING ? (
        <ReportListingTable manager={manager} />
      ) : defaultTab === TAB_REQUIREMENT_LISTING ? (
        <RequirementListing manager={manager} />
      ) : defaultTab === TAB_NEW_PROJECT_LISTING ? (
        <NewProjectListing manager={manager} />
      ) : defaultTab === TAB_CONTACT_US_LISTING ? (
        <ContactUsListing manager={manager} />
      ) : defaultTab === TAB_PROPERTY_LISTING ? (
        <PropertListing manager={manager} />
      ) : defaultTab === TAB_BLOG_LISTING ? (
        <BlogListing manager={manager} />
      ) : defaultTab === TAB_SUGGESTION_AND_COMPLAINT_LISTING ? (
        <SuggestionComplaintsListing manager={manager} />
      ) : null}
    </div>
  );
}

export default Query;
